import React from "react"
import { Flex, Heading, VStack, Text } from "@chakra-ui/react"
import { Icon } from "../../"

export default function ReviewsItem({ name, review }) {
  return (
    <Flex flex={1} h="full" layerStyle="foreground">
      <Flex
        bgGradient="linear(to-b, primary.200, primary.700)"
        color="base.900"
        py={5}
        px={2}
      >
        <Icon name="quotes" boxSize={7} />
      </Flex>
      <VStack bg="base.d100" justify="space-between" spacing={6} flex={1} p={5}>
        <Text w="full">{review}</Text>
        <Heading
          as="h6"
          size="lg"
          w="full"
          textAlign="right"
          color="primary.200"
        >
          {name}
        </Heading>
      </VStack>
    </Flex>
  )
}
